import React, { FC } from 'react';
import { Box } from '@wix/design-system';
import s from '../styles/Categories.scss';
import { useSetCurrentCategoryValue } from '../../../context/dropshippingContext';
import { Footer } from '../../../components/Footer';
import { useVisibleCategories } from '../hooks/useVisibleCateogries';
import { useSaveCategoryValue } from '../hooks/useSaveCategoryValue';
import { MobileCategoriesSelector } from './MobileCategoriesSelector';

export interface MobileCategoriesProps {}

export const MobileCategories: FC<MobileCategoriesProps> = () => {
  const { saveCategoryValue, isLoading, categoryValue } = useSaveCategoryValue();
  const setCategoryValue = useSetCurrentCategoryValue();
  const visibleCategories = useVisibleCategories({});

  return (
    <Box className={s.card} height="100%">
      <Box direction="vertical" height="100%" gap={2}>
        <MobileCategoriesSelector
          categories={visibleCategories}
          selectedCategory={categoryValue}
          onCategorySelect={setCategoryValue}
        />

        <Footer isDisabled={!categoryValue || isLoading} onClick={saveCategoryValue} />
      </Box>
    </Box>
  );
};
